import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch (err) { console.warn("payment status poll failed, retrying", err?.message); }
      attempts.current += 1;
      if (attempts.current > 12) { setStatus("timeout"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params]);

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center p-6" data-testid="payment-success-page">
      <div className="card-soft p-12 max-w-md w-full text-center">
        {status === "checking" && (
          <><Loader2 className="w-12 h-12 text-primary animate-spin mx-auto mb-6" />
            <h1 className="font-heading font-bold text-2xl mb-2">Confirming payment…</h1>
            <p className="text-secondary text-sm">Activating your subscription.</p></>
        )}
        {status === "paid" && (
          <><CheckCircle2 className="w-14 h-14 text-[#0F9D77] mx-auto mb-6" />
            <h1 className="font-heading font-bold text-2xl mb-2">Subscription active</h1>
            <p className="text-secondary text-sm mb-8">Your Trinity testing agents are ready to deploy.</p>
            <Button onClick={() => navigate("/config")} data-testid="go-config-btn"
              className="rounded-sm w-full h-11 bg-[#2A1E9E] hover:bg-[#3A2DB8] text-white font-semibold">Configure environment</Button>
          </>
        )}
        {["error", "timeout"].includes(status) && (
          <><XCircle className="w-14 h-14 text-[#E5325F] mx-auto mb-6" />
            <h1 className="font-heading font-bold text-2xl mb-2">Payment not confirmed</h1>
            <p className="text-secondary text-sm mb-8">If you were charged, it may take a moment. Check your dashboard.</p>
            <Button onClick={() => navigate("/dashboard")} className="rounded-sm w-full h-11 border border-border" variant="outline">Go to dashboard</Button>
          </>
        )}
      </div>
    </div>
  );
}
